module.exports = __webpack_public_path__ + "static/media/Personify.8e795ffe.svg";